import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	OIL_BLOCK_FEATURE_KEY,
	OilBlockState,
	OilBlockPartialState,
	oilBlockAdapter
} from './oil-block.reducer';

// Lookup the 'OilBlock' feature state managed by NgRx
export const getOilBlockState = createFeatureSelector<
	OilBlockPartialState,
	OilBlockState
>(OIL_BLOCK_FEATURE_KEY);

const { selectAll, selectEntities } = oilBlockAdapter.getSelectors();

export const getOilBlockLoaded = createSelector(
	getOilBlockState,
	(state: OilBlockState) => state.loaded
);

export const getOilBlockError = createSelector(
	getOilBlockState,
	(state: OilBlockState) => state.error
);

export const loadingOilBlock = createSelector(
	getOilBlockState,
	(state: OilBlockState) => state.loaded
);

export const getAllOilBlock = createSelector(
	getOilBlockState,
	(state: OilBlockState) => selectAll(state)
);

export const getOilBlockEntities = createSelector(
	getOilBlockState,
	(state: OilBlockState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getOilBlockState,
	(state: OilBlockState) => state.selectedOilBlockId
);

export const getSelected = createSelector(
	getOilBlockEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
